<template>
    <div>
        <div v-if="reloadingTaskDrawer" class="text-center py-12 my-12" style="width: 100%">
            <v-progress-circular
                indeterminate 
                color="primary darken-1" 
                class="my-12 py-12" 
                size="130" 
                width="8">
            </v-progress-circular>
        </div>

        <v-card v-else class="pa-0 ma-0 trans-bkg" flat>
            <v-card-text>
                <v-form ref="task_form">
                    <v-row>
                        <v-col cols="12" class="px-1">
                            <v-text-field
                                v-model="item.label"
                                label="Task Label"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.status == 'not_applicable'">
                        <v-col class="px-1">
                            <v-select
                                v-model="item.status"
                                :items="taskStatusList"
                                label="Status"
                                required
                                :rules="[value => !!value || 'Required.']"
                                @change="storeCompletionDate"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="!item.status || item.status != 'not_applicable'">
                        <v-col cols="6" class="px-1">
                            <v-select
                                v-model="item.status"
                                :items="taskStatusList"
                                label="Status"
                                required
                                :rules="[value => !!value || 'Required.']"
                                @change="storeCompletionDate"
                            />
                        </v-col>
                        <v-col cols="6" class="px-1">
                            <v-select
                                v-model="item.priority"
                                :items="priorityList"
                                label="Priority"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.status != 'not_applicable' && (!item.responsible_party || item.responsible_party !== 'srg')">    
                        <v-col
                            cols="12" class="px-1">
                            <v-select
                                v-model="item.responsible_party"
                                :items="responsiblePartyList"
                                label="Responsible Party"
                                required
                                :rules="[value => !!value || 'Required.']"
                                @change="onSelectionChange"
                            />
                        </v-col>
                    </v-row>

                    <v-row v-if="item.status != 'not_applicable' && item.responsible_party === 'srg'">
                        <v-col cols="6" class="px-1">
                            <v-select
                                v-model="item.responsible_party"
                                :items="responsiblePartyList"
                                label="Responsible Party"
                                required
                                :rules="[value => !!value || 'Required.']"
                                @change="onSelectionChange"
                            />
                        </v-col>
                        <v-col cols="6" class="px-1">
                            <v-select
                                v-model="item.owner_id"
                                :items="ownerList"
                                label="Owner"
                                :required="item.responsible_party === 'srg'"
                                :rules="[value => !!value || item.responsible_party !== 'srg' || 'Required.']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.status != 'not_applicable' && item.responsible_party === 'srg'">
                        <v-col cols="6" class="px-1">
                            <v-select
                                v-model="item.complexity"
                                :items="complexityList"
                                label="Complexity"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                        <v-col cols="6" class="px-1">
                            <v-select
                                v-model="item.duration"
                                :items="durationList"
                                label="Duration"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.status != 'not_applicable'">
                        <v-col cols="12" class="px-1">
                            <v-menu
                                ref="menu1"
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        id="psr_date_picker"
                                        label="Due Date"
                                        v-model="selectedDueDate"
                                        hint="Click the month to quickly change years"
                                        outlined
                                        persistent-hint
                                        prepend-icon="mdi-calendar"
                                        ref="input"
                                        v-on="on"
                                        :rules="[value => !!value || 'Required.']"
                                        required
                                    />
                                </template>
                                <v-date-picker
                                    no-title
                                    v-model="selectedDueDate"
                                    @input="onDueDateInput"
                                />
                                <!-- :min="getMinimumDate()" -->
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="px-1">
                            <div v-if="item.status != 'not_applicable' && item.responsible_party === 'srg'" 
                                class="d-flex align-center">
                                <span class="grey--text text--darken-1 external_text">External</span>
                                <v-switch
                                    class="ml-2"
                                    label="Internal"
                                    v-model="item.internal">
                                </v-switch>
                            </div>
                        </v-col>
                        <v-col cols="6" class="px-1">
                            <div v-if="item.task_id" class="d-flex justify-end align-center">
                                <span class="grey--text text--darken-1 external_text">Hidden</span>
                                <v-switch
                                    class="ml-2"
                                    label="Visible"
                                    v-model="item.is_visible">
                                </v-switch>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="px-1">
                            <div class="d-block info--text mb-1">Notes</div>
                            <WysiwygEditor
                                :key="`task-notes-${item.task_id || 'new'}`"
                                :value="formattedNotes"
                                @input="val => formattedNotes = val"
                                style="width: 100%;"
                                :toolbar="quickNotesToolbar">
                            </WysiwygEditor>
                            <!-- <div class="d-block d-flex justify-end">
                                <v-btn 
                                    color="primary darken-1" 
                                    class="d-flex d-block justify-end ml-1 mt-n3 mb-1"
                                    auto-grow
                                    outlined
                                    x-small
                                    @click="saveQuickNotes({project_id: projectDetails.project_id, quick_notes: projectDetails.quick_notes})">
                                    save notes
                                </v-btn>
                            </div> -->
                        </v-col>
                    </v-row>
                    <v-row v-if="showEmailTemplate && item.email_template">
                        <v-col cols="12" class="px-1">
                            <div class="d-flex justify-end">
                                <v-btn 
                                    small
                                    text
                                    class="ma-0 py-0" 
                                    color="primary darken-1"
                                    @click="startEmailWithTemplate()">
                                    Start a new email w/ this template
                                </v-btn>
                            </div>
                            <v-card 
                                elevation="0"
                                class="py-3 px-5" 
                                style="border: 1px solid #CCC">
                                <div v-html="emailTemplateContent"></div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
                            
            <v-card-actions class="pt-2 px-2 justify-end">
                <!-- 
                <div class="justify-start">
                    <v-btn
                        v-if="item.task_id"
                        color="error darken-1"
                        text
                        @click="remove"
                    >
                        Delete
                    </v-btn>
                </div> -->

                <div class="d-flex">
                    <v-btn
                        color="primary lighten-2 info--text"
                        class="d-inline"
                        @click="save()">
                        Save
                    </v-btn>

                    <v-btn
                        v-if="['completed', 'not_applicable'].includes(editedItem.status)"
                        color="xtralight_primary primary--text"
                        class="d-inline ml-3"
                        @click="save(true)">
                        Save & Get Next Task
                    </v-btn>
                </div>
            </v-card-actions>

            <ProjectReportTaskHistory v-if="item.task_id" :task_id="item.task_id" />
            
        </v-card>
    </div>
</template>


<script>
    import axios from 'axios';
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment';  
    import { 
        complexityItems,
        durationItems,
        inactiveTaskOwnerIds,
        ownerItems,
        priorityItems,
        taskStatusItems, 
        responsiblePartyItems, 
        startTimeItems
    } from '../helpers/constants';
    import ProjectReportTaskHistory from './ProjectReportTaskHistory.vue';
    import WysiwygEditor from './WysiwygEditor.vue';
    import { quickNotesToolbar } from './shared/editorToolbars';

    export default {
        name: 'ProjectReportDialog',

        components: {
            ProjectReportTaskHistory,
            WysiwygEditor
        },

        props: {
            editedItem: Object,
            drawerOpen: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            complexityList () {
                return Object.keys(complexityItems).map(key => ({ value: key, text: complexityItems[key]}));
            },

            durationList () {
                return Object.keys(durationItems).map(key => ({ value: key, text: durationItems[key]}));
            },

            item () {
                if ( this.editedItem.task_id ) {
                    return this.editedItem;
                } else {
                    const { item = {} } = this.editedItem;

                    return {
                        ...item,
                        status: item.status || 'not_started',
                        order_number: this.editedItem.order_number || 0,
                        projectstep_id: this.editedItem.projectstep_id,
                        email_template: this.editedItem.email_template
                    };
                }
            },

            emailTemplateContent: {
                get() {
                    if ( this.editedItem.email_template && this.emailTemplateArray.length ) {
                        const itemEmailTemplateContent = this.emailTemplateArray.find(item => item.value === this.editedItem.email_template)
                        this.showEmailTemplate = true;
                        return itemEmailTemplateContent.content || ''
                    } else {
                        this.showEmailTemplate = false;
                        return '';
                    }
                },
                set(value) {
                    if (this.editedItem.email_template) {
                        const body = this.emailTemplateArray.find(item => item.value === this.editedItem.email_template);
                        if (body) {
                            body.content = value;
                        }
                    }
                }
            },

            emailTemplateSubject: {
                get() {  
                    if ( this.editedItem.email_template && this.emailTemplateArray.length ) {
                        const itemEmailTemplateSubject = this.emailTemplateArray.find(item => item.value === this.editedItem.email_template)
                        this.showEmailTemplate = true;
                        return itemEmailTemplateSubject.subject || ''
                    } else {
                        this.showEmailTemplate = false;
                        return '';
                    }
                },
                set(value) {
                    if (this.editedItem.email_template) {
                        const subject = this.emailTemplateArray.find(item => item.value === this.editedItem.email_template);
                        if (subject) {
                            subject.subject = value;
                        }
                    }
                }
            },

            ownerList () {
                const currentOwnerId = this.item && this.item.owner_id ? String(this.item.owner_id) : ''

                return Object.keys(ownerItems)
                    .filter(key => !inactiveTaskOwnerIds.includes(key) || key === currentOwnerId)
                    .map(key => ({
                        text: inactiveTaskOwnerIds.includes(key)
                            ? `${ownerItems[key]} (inactive)`
                            : ownerItems[key],
                        value: key
                    }))
                    .sort((a, b) => a.text.localeCompare(b.text));
            },

            priorityList () {
                return Object.keys(priorityItems).map(key => ({ value: key, text: priorityItems[key]}));
            },

            taskStatusList () {
                return Object.keys(taskStatusItems).map(key => ({ value: key, text: taskStatusItems[key]}));
            },

            responsiblePartyList () {
                return Object.keys(responsiblePartyItems).map(key => ({ value: key, text: responsiblePartyItems[key]}));
            },

            formattedNotes: {
                get() {
                    return this.editedItem.notes ? this.editedItem.notes.replace(/''/g, "'") : '';
                },
                set(value) {
                    this.item.notes = value;
                    this.editedItem.notes = value.replace(/'/g, "'");
                }
            },

        },

        data () {
            return {
                dateMenu: false,
                quickNotesToolbar,
                taskStatusItems,
                responsiblePartyItems,
                startTimeItems,
                formattedEmailTemplate: '',
                emailTemplateSelection: '',
                emailTemplateArray: [],
                // emailTemplateSubject: '',
                // emailTemplateContent: '',
                showEmailTemplate: false,
                emails: [],
                existingTaskData: {},
                activeTaskBaselineKey: '',
                reloadingTaskDrawer: false,
                selectedDueDate: ''
            }
        },

         watch: {
            drawerOpen: {
                handler(isOpen) {
                    if (!isOpen) {
                        this.existingTaskData = {};
                        this.activeTaskBaselineKey = '';
                        this.selectedDueDate = '';
                        return;
                    }

                    this.syncSelectedDueDate(this.editedItem, true);
                    this.initializeTaskBaseline(this.editedItem);
                },
                immediate: true
            },
            editedItem: {
                handler( newVal ) {
                    this.syncSelectedDueDate(newVal);
                    this.initializeTaskBaseline(newVal);
                },
                immediate: true,
                deep: true
            },
            selectedDueDate(newVal) {
                this.setTaskDueDate(newVal);
            }
        },

        mounted () {
            this.getTemplateOptions()
        },

        methods: {
            cloneTaskData(source = {}) {
                try {
                    return JSON.parse(JSON.stringify(source));
                } catch (error) {
                    return { ...source };
                }
            },

            buildTaskBaselineKey(taskData = {}) {
                const flatTaskId = taskData.task_id;
                const nestedTaskId = taskData.item && taskData.item.task_id;
                const taskId = flatTaskId || nestedTaskId;

                if (taskId) {
                    return `task:${taskId}`;
                }

                const projectStepId = taskData.projectstep_id || (taskData.item && taskData.item.projectstep_id) || '';
                const orderNumber = taskData.order_number || (taskData.item && taskData.item.order_number) || '';
                return `new:${projectStepId}:${orderNumber}`;
            },

            initializeTaskBaseline(taskData = {}) {
                if (!taskData || Object.keys(taskData).length === 0) return;

                const baselineKey = this.buildTaskBaselineKey(taskData);
                if (baselineKey === this.activeTaskBaselineKey && Object.keys(this.existingTaskData).length) {
                    return;
                }

                this.activeTaskBaselineKey = baselineKey;
                this.storeTaskData(taskData);
            },

            syncSelectedDueDate(taskData = {}, force = false) {
                if (!taskData || Object.keys(taskData).length === 0) {
                    if (force) {
                        this.selectedDueDate = '';
                    }
                    return;
                }

                const baselineKey = this.buildTaskBaselineKey(taskData);
                if (force || baselineKey !== this.activeTaskBaselineKey || !this.selectedDueDate) {
                    this.selectedDueDate = this.getTaskDueDate(taskData);
                }
            },

            getTaskDueDate(taskData) {
                if (!taskData) return '';

                const sourceDate = taskData.date || (taskData.item && taskData.item.date);
                return sourceDate ? this.formatMenuDate(sourceDate) : '';
            },

            setTaskDueDate(dateValue) {
                if (this.editedItem && typeof this.editedItem === 'object') {
                    this.editedItem.date = dateValue || null;

                    if (this.editedItem.item && typeof this.editedItem.item === 'object') {
                        this.editedItem.item.date = dateValue || null;
                    }
                }

                if (this.item && typeof this.item === 'object') {
                    this.item.date = dateValue || null;
                }
            },

            onDueDateInput(dateValue) {
                this.selectedDueDate = dateValue;
                this.dateMenu = false;
            },

            onSelectionChange() {
                this.$forceUpdate();
            },

            storeTaskData (taskData = this.editedItem) {
                this.existingTaskData = this.cloneTaskData(taskData);
            },

            storeCompletionDate() {
                const { status } = this.item;
                if (status === 'completed') {
                    this.item.completion_date = new Date()
                } else {
                    this.item.completion_date = null;
                }
            },

            formatMenuDate: function ( thisDate ) {
                if (!thisDate) return '';

                return new Date(thisDate).toISOString().split('T')[0]
            },

            formatDate: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : '';
            },

            getMinimumDate () {
                // "today" - nothing from today backwards
                const now = new Date();
                const year = String(now.getFullYear()).padStart(4, '0');
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const date = String(now.getDate()).padStart(2, '0');

                return `${year}-${month}-${date}`;
            },

            close () {
                this.existingTaskData = {};
                this.$emit('close');
            },

            async save ( getNextTask = false ) {
                // console.log('submit',this.item)
                if (this.$refs.task_form.validate()) {
                    // Proceed with save operation
                    const task_data_rs = await this.saveTaskData( getNextTask );
                    const responseData = task_data_rs && task_data_rs.data ? task_data_rs.data : task_data_rs;
                    
                    if ( !getNextTask ) {
                        this.close();
                        this.$emit('save', this.editedItem);
                    } else {
                        const nextTask = responseData && responseData.nextTask ? responseData.nextTask : null;

                        if ( nextTask ) {
                            this.reloadingTaskDrawer = true;
                            setTimeout(() => {
                                this.reloadingTaskDrawer = false;
                                this.existingTaskData = { ...nextTask };
                                this.$emit('next-task', nextTask);
                            }, 800)
                        } else {
                            this.close();
                            this.$emit('save', this.editedItem);
                        }
                    }                    
                } else {
                    // Show validation errors
                    this.$refs.task_form.$el.scrollIntoView({ behavior: 'smooth' });
                }
            },

            async saveTaskData ( getNextTask = false ) {
                const { 
                    complexity, 
                    duration,
                    internal, 
                    label, 
                    order_number,
                    owner_id, 
                    priority, 
                    projectstep_id, 
                    responsible_party, 
                    status,
                    is_visible, 
                    task_id,
                    notes
                } = this.item;

                const payload = {
                    complexity, 
                    date: this.selectedDueDate,
                    duration,
                    internal, 
                    label, 
                    order_number,
                    owner_id, 
                    priority, 
                    projectstep_id, 
                    responsible_party, 
                    status, 
                    is_visible,
                    task_id,
                    notes,
                    getNextTask
                };
                
                payload.previous_data = this.existingTaskData
                payload.isSRG = true

                let taskSave                
                if ( task_id ) {
                    taskSave = await axios.put(`${appUrls.api}/api/project_step/${projectstep_id}/task/${task_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        payload
                    })
                } else {
                    taskSave = await axios.post(`${appUrls.api}/api/admin/project_step/${projectstep_id}/task`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        payload
                    })
                }
                
                return taskSave;
            },

            async remove () {
                await this.removeTask();
                this.close();

                this.$emit('save', this.editedItem)
            },

            removeTask () {
                const { task_id } = this.item;
                const taskRemove = axios.delete(`${appUrls.api}/api/task/${task_id}`,{
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                });

                return taskRemove;
            },

            async getTemplateOptions() {
                try {
                    const get_template_options = await axios.get(`${appUrls.api}/api/admin/email_templates/task_template`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    });
                    const { outcome, templates } = get_template_options.data;
                    
                    if ( outcome && templates.length > 0 ) {
                        this.emailTemplateArray = templates.map(template => ({
                            value:   template.status_id,
                            text:    template.email_name || 'Unnamed Template', // Fallback for missing names
                            subject: template.subject_text || '[No Subject]', // Fallback for missing subject
                            content: template.body_text || '[No Content]', // Fallback for missing content
                        }));
                        // console.log(this.emailTemplateArray)
                    }
                } catch (error) {
                    console.error('Error fetching task-related email templates:', error);
                }
            },

            async getEmailAddresses() {
                try {
                    // const get_template_addresses = await axios.get(`${appUrls.api}/api/admin/email_addresses/${module_id}`, {
                    //     headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    // });

                    // if ( get_template_addresses.data.outcome ) {
                    //     this.emails = get_template_addresses.data.emails.map(template => ({
                    //         value:   template.status_id,
                    //         text:    template.email_name || 'Unnamed Template', // Fallback for missing names
                    //         subject: template.subject_text || '[No Subject]', // Fallback for missing subject
                    //         content: template.body_text || '[No Content]', // Fallback for missing content
                    //     }));
                    // } else {
                    //     console.error('Failed to fetch email templates: No outcome');
                    // }
                } catch (error) {
                    console.error('Error fetching task-related email templates:', error);
                }
            },

            startEmailWithTemplate: function () {
                if (this.emailTemplateContent == '' || this.emailTemplateContent == undefined) {
                    console.error('Email template content is empty or undefined.');
                } else {
                    // Convert HTML to plain text while preserving line breaks
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(this.emailTemplateContent, 'text/html');

                    // Replace block-level tags and <br> tags with line breaks
                    const htmlWithLineBreaks = doc.body.innerHTML
                        .replace(/<\/(p)>/gi, '\n\n') // Double line break for paragraphs
                        .replace(/<\/(div|h[1-6]|li)>/gi, '\n') // Single line break for other block-level tags
                        .replace(/<br\s*\/?>/gi, '\n') // Handle <br> and <br/> tags
                        .replace(/<li>/gi, '- '); // Add a dash for list items

                    // Extract plain text
                    const plainText = htmlWithLineBreaks.replace(/<[^>]+>/g, ''); // Remove remaining HTML tags

                    // Define email fields
                    // const to = encodeURIComponent('recipient@example.com'); // Replace with actual recipient
                    // const cc = encodeURIComponent('cc@example.com'); // Replace with actual CC recipient
                    // const bcc = encodeURIComponent('bcc@example.com'); // Replace with actual BCC recipient
                    const subject = encodeURIComponent(this.emailTemplateSubject);
                    const body = encodeURIComponent(plainText.trim()); // Trim extra spaces or line breaks

                    // Construct mailto link
                    // const mailtoLink = `mailto:${to}?cc=${cc}&bcc=${bcc}&subject=${subject}&body=${body}`;
                    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
                    window.open(mailtoLink, '_blank');
                }
            }
        }
    }
</script>

<style scoped>
    .external_text {
        font-size: 1.02rem;
    }
    .trans-bkg {
        background-color: transparent !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ProjectReportDialog.vue